export const types = [{ value: 'outcome', label: 'Расход' }, { value: 'income', label: 'Приход' }]

export const taskStatuses = [
    { id: 'todo', title: 'Запланировано', color: '#ffdd57' },
    { id: 'doing', title: 'Выполняется', color: '#3298dc' },
    { id: 'done', title: 'Сделано', color: '#48c774' },
]
